import { ChangeDetectionStrategy, Component, computed, input, output, signal, TemplateRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FileSelectEvent, FileUpload } from "primeng/fileupload";
import { UiCoreFileSizePipe } from "../../../../pipes";
import { UiCoreFileUploadOptions } from "../../models/ui-core-file-upload.model";
import { Button } from "primeng/button";

@Component({
  selector: "rr-ui-core-file-upload",
  imports: [CommonModule, FileUpload, UiCoreFileSizePipe, Button],
  templateUrl: "./ui-core-file-upload.component.html",
  styleUrl: "./ui-core-file-upload.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCoreFileUploadComponent {
  // I/O
  uploadOptions = input<UiCoreFileUploadOptions>();
  uploadTpl = input<TemplateRef<{ files: File[] }>>();
  resetFiles = input<boolean>(false);
  selectFile = output<FileSelectEvent>();

  // Template variables
  defaultOptions = signal<UiCoreFileUploadOptions>({
    browseLabel: "Browse File",
    maxFileSize: 5242880, // 5MB
    multiple: false,
    toolbarLabel: "Drag and drop files here to upload.",
    acceptedFileType: ".xlsx",
    styleClass: "",
    showRemoveButton: true,
    disabled: false,
  });
  options = computed(() => {
    return { ...this.defaultOptions(), ...this.uploadOptions() };
  });

  onRemoveFile(files: File[], index: number) {
    files.splice(index, 1);
  }
}
